(function () {
  const dialog = document.getElementById('acqua-cart-drawer');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  let revision = 0;
  let pending = false;
  let opener = null;
  let priorOverflow = '';
  let closeTimer = null;
  let dismissedDuringMutation = false;
  let adding = false;
  let pendingIdentity = null;
  let beforeItems = new Map();
  const reducedMotion = () => window.matchMedia?.('(prefers-reduced-motion: reduce)').matches === true;
  const activity = dialog.querySelector('[data-acqua-drawer-activity]');
  function captureItems() {
    beforeItems = new Map((window.acquaLinkedCart?.state?.cart?.items || []).map(item => [item.key, item.quantity]));
  }
  const status = dialog.querySelector('[data-acqua-drawer-status]');
  const cartUrl = () => window.Theme?.routes?.cart_url || '/cart';
  const active = () => dialog.open;
  function stoqPreorderInterceptExpected(button) {
    const config = window._RestockRocketConfig || window._StoqConfig;
    const acknowledgement = document.getElementById('restock-rocket-acknowledge-preorder');
    if (config?.cachedSettings?.preorder_enabled !== true && !acknowledgement) return false;
    const form = button?.closest?.('form[action*="/cart/add"]');
    if (!form) return false;
    const variantId = Number(new FormData(form).get('id'));
    if (!variantId) return false;
    const directIds = Array.isArray(config?.preorderVariantIds)
      ? config.preorderVariantIds
      : config?.preorderVariantIds?.preorder_variant_ids || [];
    const ids = [
      ...directIds,
      ...(config?.cachedPreorderVariantIds?.preorder_variant_ids || []),
    ].map(Number);
    return ids.includes(variantId);
  }
  function beginAdd(button) {
    const deferOpen = stoqPreorderInterceptExpected(button);
    beforeMutation({ adding: true, deferOpen });
    return deferOpen && button instanceof HTMLElement;
  }
  function setPending(value) {
    pending = value;
    if (activity) {
      activity.hidden = !value || Boolean(pendingIdentity);
      const label = activity.querySelector('[data-acqua-drawer-activity-text]');
      if (label) label.textContent = adding ? 'Adding your selection…' : 'Updating your cart…';
    }
    dialog.querySelectorAll('[name="checkout"]').forEach(button => { button.disabled = value || dialog.hasAttribute('data-refresh-failed'); });
    dialog.toggleAttribute('data-loading', value);
    dialog.querySelector('[data-acqua-drawer-content]')?.setAttribute('aria-busy', String(value));
    document.dispatchEvent(new CustomEvent('acqua:cart-external-pending', { detail: { active: value, adding, group: pendingIdentity?.group, keys: pendingIdentity?.key ? [pendingIdentity.key] : [], message: adding ? 'Adding your selection…' : 'Updating your cart…' } }));
  }
  function show() {
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; dialog.removeAttribute('data-closing'); }
    if (active()) return;
    opener = document.activeElement;
    priorOverflow = document.documentElement.style.overflow;
    if (!reducedMotion()) dialog.setAttribute('data-entering', '');
    dialog.showModal();
    requestAnimationFrame(() => requestAnimationFrame(() => dialog.removeAttribute('data-entering')));
    document.documentElement.style.overflow = 'hidden';
    dialog.querySelector('[data-acqua-drawer-close]')?.focus({ preventScroll: true });
  }
  function closeDrawer() {
    if (!active() || closeTimer) return;
    if (pending) dismissedDuringMutation = true;
    if (reducedMotion()) { dialog.close(); return; }
    dialog.setAttribute('data-closing', '');
    closeTimer = setTimeout(() => { closeTimer = null; dialog.removeAttribute('data-closing'); dialog.close(); }, 340);
  }
  function fail() {
    status.textContent = 'We could not refresh your cart. Open the full cart to check your items.';
    dialog.setAttribute('data-refresh-failed', '');
    dialog.querySelectorAll('[name="checkout"]').forEach(button => { button.disabled = true; });
  }
  async function render({ verify = false, open = false } = {}) {
    if (open && !dismissedDuringMutation) show();
    const current = ++revision;
    const focused = document.activeElement;
    const control = focused?.closest?.('acqua-linked-selection');
    const identity = pendingIdentity || control && { key: control.getAttribute('line-key'), group: control.getAttribute('group'), action: focused.getAttribute('data-acqua-quantity-action'), input: focused.tagName === 'INPUT' };
    setPending(true);
    status.textContent = 'Updating your cart…';
    try {
      const api = window.acquaLinkedCart;
      if (!api) throw new Error('Cart controls unavailable');
      if (verify) await api.refresh();
      if (current !== revision) return;
      const url = new URL(cartUrl(), location.href);
      url.searchParams.set('section_id', 'acqua-cart-drawer');
      const response = await fetch(url.href, { cache: 'no-store', signal: AbortSignal.timeout(15000), headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error('Cart section unavailable');
      const html = await response.text();
      if (current !== revision) return;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const next = parsed.querySelector('#acqua-cart-drawer [data-acqua-drawer-content]');
      const target = dialog.querySelector('[data-acqua-drawer-content]');
      if (!next || !target) throw new Error('Cart section missing');
      const expanded = target.querySelector?.('[data-acqua-drawer-savings]')?.open;
      const nextSavings = next.querySelector?.('[data-acqua-drawer-savings]');
      if (nextSavings && expanded !== undefined) nextSavings.open = expanded;
      const changedKeys = new Set((api.state.cart?.items || []).filter(item => beforeItems.get(item.key) !== item.quantity).map(item => item.key));
      next.querySelectorAll?.('[data-cartitem-key]').forEach(row => {
        if (changedKeys.has(row.getAttribute('data-cartitem-key'))) row.setAttribute('data-acqua-item-entering', '');
      });
      const expandedConfigurations = new Set(Array.from(target.querySelectorAll?.('[data-acqua-drawer-configuration][open]') || []).map(details => details.closest('[data-cartitem-key]')?.getAttribute('data-cartitem-key')));
      next.querySelectorAll?.('[data-acqua-drawer-configuration]').forEach(details => {
        details.open = expandedConfigurations.has(details.closest('[data-cartitem-key]')?.getAttribute('data-cartitem-key'));
      });
      target.replaceWith(next);
      const count = dialog.querySelector('[data-acqua-drawer-count]');
      if (count) count.textContent = next.dataset.itemCount || '0';
      captureItems();
      dialog.removeAttribute('data-refresh-failed');
      dialog.removeAttribute('data-operation-error');
      status.textContent = api.state.message || (!api.state.verified ? 'Please check your cart before checking out.' : Number(next.dataset.itemCount) ? '' : 'Your cart is empty.');
      const cart = api.state.cart;
      if (cart) window.dispatchEvent(new CustomEvent('cartcount:update', { detail: cart }));
      document.dispatchEvent(new CustomEvent('acqua:cart-presentation-refresh'));
      if (identity && active()) {
        const replacement = Array.from(dialog.querySelectorAll('acqua-linked-selection')).find(el => identity.group ? el.getAttribute('group') === identity.group && el.getAttribute('role-kind') === 'parent' : el.getAttribute('line-key') === identity.key);
        const button = identity.input ? replacement?.querySelector('input') : replacement?.querySelector('[data-acqua-quantity-action="' + identity.action + '"]');
        (button || dialog.querySelector('[data-acqua-drawer-close]'))?.focus({ preventScroll: true });
      }
    } catch (_error) {
      if (current === revision) fail();
    } finally {
      if (current === revision) { setPending(false); adding = false; pendingIdentity = null; }
    }
  }
  document.addEventListener('acqua:cart-state', event => {
    if (!active() || pending || dialog.hasAttribute('data-refresh-failed')) return;
    const state = event.detail || {};
    status.textContent = state.busy ? 'Checking your cart…' : state.message || (state.verified ? '' : 'Please check your cart before checking out.');
  });
  function beforeMutation(options = {}) {
    revision += 1;
    captureItems();
    adding = options.adding === true;
    const control = document.activeElement?.closest?.('acqua-linked-selection');
    pendingIdentity = control ? { key: control.getAttribute('line-key'), group: control.getAttribute('group'), action: document.activeElement.getAttribute('data-acqua-quantity-action'), input: document.activeElement.tagName === 'INPUT' } : null;
    if (adding) { dismissedDuringMutation = false; if (!options.deferOpen) show(); }
    if (active()) setPending(true);
  }
  function settled(options = {}) {
    const result = active() ? render({ verify: options.verify === true }) : Promise.resolve(setPending(false));
    const settledRevision = revision;
    void result.then(() => {
      if (settledRevision !== revision) return;
      if (options.failed && active()) {
        dialog.setAttribute('data-operation-error', '');
        status.textContent = options.message || window.acquaLinkedCart?.state?.message || 'That selection could not be added. Please check your options and try again.';
      }
    });
  }
  async function nativeAdded() {
    const api = window.acquaLinkedCart;
    if (!api || typeof api.refresh !== 'function') {
      settled({ failed: true, message: 'Your cart changed, but it could not be checked. Open the full cart before continuing.' });
      return { status: 'UNVERIFIED', cart: null };
    }
    const result = await api.refresh();
    if (result?.status !== 'VERIFIED' || !Array.isArray(result.cart?.items)) {
      settled({ failed: true, message: 'Your cart changed, but it could not be checked. Open the full cart before continuing.' });
      return result;
    }
    window.dispatchEvent(new CustomEvent('acqua:cart-mutation', { detail: {
      cart: result.cart,
      source: 'acqua-native-add',
      deliberate: true,
      operationId: window.crypto.randomUUID(),
      action: 'add',
    } }));
    await render({ open: true });
    return result;
  }
  const savingsAnimations = new WeakMap();
  dialog.addEventListener('click', event => {
    const summary = event.target.closest?.('[data-acqua-drawer-savings] > summary');
    if (!summary) return;
    const details = summary.parentElement;
    if (reducedMotion() || typeof details.animate !== 'function') return;
    event.preventDefault();
    const previous = savingsAnimations.get(details);
    const opening = previous ? !previous.opening : !details.open;
    const from = details.getBoundingClientRect().height;
    previous?.animation.cancel();
    details.open = true;
    const to = opening ? details.getBoundingClientRect().height : summary.getBoundingClientRect().height + 2;
    const animation = details.animate([{ height: from + 'px' }, { height: to + 'px' }], { duration: 260, easing: 'cubic-bezier(.22,.75,.25,1)' });
    savingsAnimations.set(details, { animation, opening });
    animation.onfinish = () => {
      details.open = opening;
      savingsAnimations.delete(details);
    };
  });
  function guard(event) {
    if (!active()) return;
    const target = event.target;
    const checkout = event.type === 'submit' ? event.submitter?.matches('[name="checkout"]') : target.closest?.('[name="checkout"], [data-acqua-checkout]');
    const quantity = target.closest?.('acqua-linked-selection');
    if ((pending || dialog.hasAttribute('data-refresh-failed') || !window.acquaLinkedCart) && (checkout || quantity)) {
      event.preventDefault(); event.stopImmediatePropagation();
    }
  }
  ['click', 'change', 'submit'].forEach(name => document.addEventListener(name, guard, true));
  document.addEventListener('acqua:open-cart', () => {
    dismissedDuringMutation = false;
    captureItems();
    void render({ verify: true, open: true });
  });
  document.addEventListener('click', event => {
    const close = event.target.closest?.('[data-acqua-drawer-close]');
    if (close && dialog.contains(close)) { closeDrawer(); return; }
    const link = event.target.closest?.('.site-header-cart--button');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault(); event.stopImmediatePropagation();
    dismissedDuringMutation = false;
    captureItems();
    void render({ verify: true, open: true });
  }, true);
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeDrawer();
  });
  dialog.addEventListener('cancel', event => { event.preventDefault(); closeDrawer(); });
  dialog.addEventListener('close', () => {
    document.documentElement.style.overflow = priorOverflow;
    if (opener?.isConnected) opener.focus({ preventScroll: true });
  });
  const quickAdds = new WeakMap();
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches?.('form.acqua-card-quick-add, form.acqua-card-hover-add, form.acqua-card-touch-action') || typeof window.AddToCartFlyout !== 'function') return;
    const button = event.submitter || form.querySelector('button[type="submit"]');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (button.disabled) return;
    quickAdds.get(form)?.unload();
    const values = Array.from(new FormData(form), ([name, value]) => ({ name, value }));
    quickAdds.set(form, new window.AddToCartFlyout(values, { atcButton: button, settings: { cartRedirection: false } }));
  }, true);
  window.acquaCartDrawer = {
    active, beforeMutation, settled,
    beginAdd,
    nativeFailed: message => settled({ failed: true, verify: true, message }),
    refreshCart: () => render(),
    openVerified: () => render({ open: true }),
    nativeAdded,
  };
  const flyout = window.AddToCartFlyout?.prototype;
  if (flyout && !flyout.__acquaStoqDeferredBound) {
    const disableAtcButton = flyout._disableAtcButton;
    const onSuccess = flyout._onSuccess;
    flyout._onInit = function () {
      this.acquaStoqDeferred = window.acquaCartDrawer.beginAdd(this.atcButton);
      this.messageBanner?.unload();
      this.announcementBar?.style.setProperty('--index-announcement-bar', '1100');
      this.utilityBar?.style.setProperty('--index-utility-bar', '1100');
    };
    flyout._disableAtcButton = function () {
      if (!this.acquaStoqDeferred) disableAtcButton.call(this);
    };
    flyout._onSuccess = function () {
      const result = onSuccess.apply(this, arguments);
      return Promise.resolve(result).then(value => {
        if (!this.settings?.cart_redirection) return window.acquaCartDrawer.nativeAdded().then(() => value);
        return value;
      });
    };
    Object.defineProperty(flyout, '__acquaStoqDeferredBound', { value: true });
  }
})();
